import apiClient from './axios'

export const getActivityLogs = async (params = {}) => {
  const { data } = await apiClient.get('/v1/activity-logs', { params })
  return data
}

export const getActivityLog = async (id) => {
  const { data } = await apiClient.get(`/v1/activity-logs/${id}`)
  return data
}
